/** @mixin listResetMixin */
/**
 * Defensive reset styles for lists.
 *
 * @example
 * import { listResetMixin } from '@zillow/constellation';
 *
 * const Component = styled.ul`
 *     ${listResetMixin}
 * `;
 *
 * <Component />
 *
 * @method
 * @return {CSSObject}
 */
export var listResetMixin = function listResetMixin() {
  return "\n    margin: 0;\n    padding: 0;\n    list-style: none;\n";
};